module.exports = __webpack_public_path__ + "img/weight-gain.e4259d05.svg";